export const ClickOutsideDirective = {
    bind(el: any, binding: any, vnode: any) {
        el.handleOutsideClick = (e: any) => {
            e.stopPropagation();
            if (!(el == e.target || el.contains(e.target))) {
                vnode.context[binding.expression](e);
            }
        };
        document.addEventListener('mousedown', el.handleOutsideClick);
        document.addEventListener('touchstart', el.handleOutsideClick);
    },
    unbind(el: any) {
        document.removeEventListener('mousedown', el.handleOutsideClick);
        document.removeEventListener('touchstart', el.handleOutsideClick);
    },
};
